import sidebar from "./sidebar.json"
import common from "./common.json"
import message from "./message.json"
import moment from "./moment.json"
import table from "./table.json"
import companyPage from "./companyPage.json"
import parameterPage from "./parameterPage.json"
import departmentPage from "./departmentPage.json"
import userPage from "./userPage.json"
import profilePage from "./profilePage.json"
import partyPage from "./partyPage.json"
import testPage from "./testPage.json"
import testProfilePage from "./testProfilePage.json"
import interfacePage from "./interfacePage.json"
import machinePage from "./machinePage.json"
import testConfig from "./testConfig.json"
import hisConnectorPage from "./hisConnectorPage.json"
import reportPage from "./reportPage.json"
import accessionNumberPage from "./accessionNumberPage.json"
import deliveryPage from "./deliveryPage.json"
import testResultPage from "./testResultPage.json"
import processPage from "./processPage.json"
import workListPage from "./workListPage.json"
import workOrderPage from "./workOrderPage.json"
import testRequestPage from "./testRequestPage.json"
import resultPage from "./resultPage.json"
import generalSetting from "./generalSetting.json"
import notificationPage from "./notificationPage.json"
import loginHistoryPage from "./loginHistoryPage.json"
import insurancePage from "./insurancePage.json"
import patientVisitPage from "./patientVisitPage.json"
import qcResultPage from "./qcResultPage.json"
import patientGroup from "./patientGroup.json"
import personalSettingPage from "./personalSettingPage.json"
import printConfigPage from './printConfigPage.json'
import pathologyCodePage from './pathologyCodePage.json'
import generalDashboard from './generalDashboard.json'

const translations = {
  sidebar,
  common,
  message,
  moment,
  table,
  companyPage,
  parameterPage,
  departmentPage,
  userPage,
  profilePage,
  partyPage,
  testPage,
  testProfilePage,
  machinePage,
  interfacePage,
  testConfig,
  hisConnectorPage,
  reportPage,
  accessionNumberPage,
  deliveryPage,
  testResultPage,
  processPage,
  workListPage,
  workOrderPage,
  testRequestPage,
  resultPage,
  generalSetting,
  notificationPage,
  loginHistoryPage,
  insurancePage,
  patientVisitPage,
  qcResultPage,
  patientGroup,
  personalSettingPage,
  printConfigPage,
  pathologyCodePage,
  generalDashboard
}

export default translations
